module.exports = __webpack_public_path__ + "static/img/logo-junto.16c0e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-junto.png
// module id = J5C0
// module chunks = 1